import React, { useState } from 'react';
import ParticlesBackground from './ParticlesBackground';
import './MainMenuScreen.css';
import './ReviewTypeSelectionScreen.css';

const ReviewTypeSelectionScreen = ({ onSelect, selectedType, onBack }) => {
  const [hoveredCard, setHoveredCard] = useState(null);
  
  const handleCardClick = (typeId) => {
    onSelect(typeId);
  };
  
  const reviewTypes = [
    {
      id: 'solvedReview',
      number: '1',
      title: 'مراجعات محلولة',
      description: 'اطلع على إجابات نموذجية وشروحات مفصلة.',
      image: '/bachelor.png',
      badge: '✓'
    },
    {
      id: 'unsolvedReview',
      number: '2',
      title: 'مراجعات غير محلولة',
      description: 'اختبر معرفتك وتدرب على حل الأسئلة بنفسك.',
      image: '/education.png',
      badge: '🔒'
    },
    {
      id: 'testSchedule',
      number: '3',
      title: 'جدول الاختبارات',
      description: 'اطلع على جدول الاختبارات للصف المطلوب.',
      image: '/bachelor.png',
      badge: '📅'
    }
  ];

  return (
    <div className="main-menu-screen">
      <ParticlesBackground count={30} />
      <div className="main-menu-container" style={{ position: 'relative' }}>
        {/* Header */}
        <div className="main-menu-header">
          <div className="header-logo">
            <img src="/logo.jpeg" alt="شعار المدرسة" className="menu-logo" />
          </div>
          <div className="header-text">
            <h1 className="main-menu-title">اختر نوع المراجعة</h1>
            <p className="main-menu-school">متوسطة وثانوية نخبة الشمال الأهلية</p>
          </div>
        </div>

        {/* Main Content - Review Type Cards */}
        <div className="main-menu-content">
          {reviewTypes.map((type, index) => (
            <div
              key={type.id}
              className={`review-type-main-card stagger-item ${hoveredCard === type.id ? 'hovered' : ''} ${selectedType === type.id ? 'selected' : ''}`}
              onClick={() => handleCardClick(type.id)}
              onMouseEnter={() => setHoveredCard(type.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="card-icon-wrapper">
                <img 
                  src={type.image} 
                  alt={type.title}
                  className="card-main-icon-image"
                />
                {type.badge && (
                  <span className={`card-badge ${type.id === 'solvedReview' ? 'badge-check' : type.id === 'testSchedule' ? 'badge-schedule' : 'badge-lock'}`}>
                    {type.badge}
                  </span>
                )}
              </div>
              <div className="card-content">
                <h2 className="card-title">
                  <span className="card-number">{type.number}.</span> {type.title}
                </h2>
                <p className="card-description">{type.description}</p>  
              </div>
              <div className="card-arrow">
                <span>›</span>
              </div>
            </div>
          ))}
          
          {/* Back Button - Directly Below Last Card */}
          {onBack && (
            <div className="back-button-wrapper">
              <button 
                className="back-button ripple-effect magnetic-button" 
                onClick={onBack}
              >
                ← رجوع
              </button>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="main-menu-footer">
          <p>مدير المدرسة: محمد نصر الدين</p>
        </div>
      </div>
    </div>
  );
};

export default ReviewTypeSelectionScreen;

